import ui, { saleTypes, saleStates, discountConditionTypes } from '../ui/sales'
import helpers from '../helpers/sales'


export default {
    data: () => ({
        saleTypes,
        saleStates,
        discountConditionTypes
    }),
    methods: {
        ...ui,
        ...helpers
    }
}